export interface NavigationService {
  /** Navigate the current page to a URL (e.g. OAuth redirect). */
  navigateTo(url: string): void;
}

class DefaultNavigationService implements NavigationService {
  navigateTo(url: string): void {
    window.location.href = url;
  }
}

let navigationService: NavigationService = new DefaultNavigationService();

export function useNavigationService(): NavigationService {
  return navigationService;
}

export function setNavigationService(service: NavigationService): void {
  navigationService = service;
}
